<template>
    <div class="">
        <field-select v-model.number="form.state_id" :readonly="readonly" placeholder="State" @change="updateState()">
            <option v-for="state in states" :value="state.id" v-text="state.name"></option>
        </field-select>
        <field-select v-model.number="form.county_id" :readonly="readonly" placeholder="County" @change="updateCounty()">
            <option v-for="county in counties" :value="county.id" v-text="county.name"></option>
        </field-select>
    </div>
</template>
<script>

    export default {

        props: {
            value: {
                type: Object,
                required: true,
            },
            data: {
                type: Array,
                required: true,
            },
            readonly: {
                required: false,
                type: Boolean,
                default: false,
            }
        },

        data() {
            return {
                form: this.value,
            }
        },

        methods: {
            updateForm() {
                this.$emit('input', this.form);
            },

            updateState() {
                // this.form.county_id = '';
                this.updateForm();
            },

            updateCounty() {
                this.updateForm();
            }
        },

        computed: {
            states() {
                return _.orderBy(_.uniqBy(this.data.map(item => {
                    return item.state;
                }), 'id'), ['name'])
            },

            counties() {
                return this.data.filter(item => {
                    return item.state.id == this.form.state_id;
                });
            }
        },

        created() {
            App.bus.$on('change-state-and-county', data => {
                this.form.state_id = this.data.find(item => {
                    return item.state.short_name == data.state;
                }).state.id;
                setTimeout(() => {
                    this.form.county_id = this.data.find(item => {
                        return (item.name.toLowerCase() == data.county.toLowerCase() && item.state.short_name == data.state)
                    }).id;
                }, 100)
            })
        }
    }
</script>
